// src/pages/Checkout.jsx — Broadway Holidays
// Booking REQUEST checkout: no online card payment. The booking is saved in the back office
// (backoffice/website-booking-submit.php → Website Bookings page + push alert) and emailed as a backup.
// Our team then calls the customer to confirm and takes payment by phone or Revolut payment link.
// src/pages/Checkout.jsx — Broadway Holidays
import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";


const WEB3FORMS_KEY = "88770258-0cc4-483a-9057-28925587750e";
const PJS = { fontFamily: "'Plus Jakarta Sans',sans-serif" };
const DS  = { fontFamily: "'DM Sans',sans-serif" };
const NAV = "#0B1F3A", NAVL = "#1e3a5c";
const GRN = "#059669";

const BC = {
  "All Inclusive":   { bg: "#065f46", txt: "#fff", light: "#d1fae5" },
  "Half Board":      { bg: "#b45309", txt: "#fff", light: "#fef3c7" },
  "Full Board":      { bg: "#6d28d9", txt: "#fff", light: "#ede9fe" },
  "Bed & Breakfast": { bg: "#1d4ed8", txt: "#fff", light: "#dbeafe" },
  "Self Catering":   { bg: "#374151", txt: "#fff", light: "#f1f5f9" },
  "Room Only":       { bg: "#6b7280", txt: "#fff", light: "#f1f5f9" },
};

const fDS2 = d => {
  try { return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }); }
  catch { return d || ""; }
};

const I = {
  Check: ({ s = 12, c = "#fff" }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>,
  Right: ({ s = 14 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>,
  Phone: ({ s = 15 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>,
  WApp:  ({ s = 15 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" /></svg>,
  Tick:  ({ s = 16 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill={GRN}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>,
  Lock:  ({ s = 14 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>,
  Card:  ({ s = 16 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg>,
};

function Field({ label, required, children, error, hint }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 5, textTransform: "uppercase", letterSpacing: ".04em", ...DS }}>
        {label}{required && <span style={{ color: "#dc2626", marginLeft: 3 }}>*</span>}
        {hint && <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 400, textTransform: "none", marginLeft: 6 }}>{hint}</span>}
      </label>
      {children}
      {error && <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4, ...DS }}>⚠ {error}</div>}
    </div>
  );
}

function Input({ value, onChange, placeholder, type = "text", error }) {
  return (
    <input type={type} value={value} onChange={onChange} placeholder={placeholder}
      style={{ width: "100%", padding: "11px 13px", border: `1.5px solid ${error ? "#fca5a5" : "#d1d5db"}`, borderRadius: 9, fontSize: 14, outline: "none", ...DS, boxSizing: "border-box", background: error ? "#fff5f5" : "#fff", transition: "border-color .15s", color: "#1e293b" }}
      onFocus={e => { if (!error) e.target.style.borderColor = NAV; }}
      onBlur={e => { if (!error) e.target.style.borderColor = "#d1d5db"; }} />
  );
}

function Sel({ value, onChange, children }) {
  return (
    <select value={value} onChange={onChange}
      style={{ width: "100%", padding: "11px 13px", border: "1.5px solid #d1d5db", borderRadius: 9, fontSize: 14, outline: "none", ...DS, boxSizing: "border-box", background: "#fff", cursor: "pointer", color: "#1e293b" }}>
      {children}
    </select>
  );
}

export default function Checkout() {
  const [sp] = useSearchParams();

  const hotelName = decodeURIComponent(sp.get("hotelName") || "Your Hotel");
  const checkIn   = sp.get("checkIn")  || "";
  const checkOut  = sp.get("checkOut") || "";
  const guests    = Number(sp.get("guests")) || 2;
  const rooms     = Number(sp.get("rooms"))  || 1;
  const totalPP   = Number(sp.get("price"))  || 0;
  const board     = decodeURIComponent(sp.get("board") || "Room Only");
  const pax       = guests * rooms;
  const nights    = checkIn && checkOut
    ? Math.max(1, Math.round((new Date(checkOut) - new Date(checkIn)) / 86400000))
    : 7;
  const totalAll   = totalPP * pax;
  const depositPP  = totalPP ? Math.max(19, Math.round(totalPP * 0.08)) : 0;
  const depositAll = depositPP * pax;
  const bcc = BC[board] || BC["Room Only"];

  const [lead, setLead] = useState({ title: "Mr", firstName: "", lastName: "", email: "", phone: "", address: "", postcode: "", specialReq: "", terms: false });
  const setL = (k, v) => setLead(p => ({ ...p, [k]: v }));

  const [paxList, setPaxList] = useState(
    Array.from({ length: Math.max(0, guests - 1) }, () => ({ title: "Mr", firstName: "", lastName: "", dob: "" }))
  );
  const setPax = (i, k, v) => setPaxList(p => p.map((x, xi) => xi === i ? { ...x, [k]: v } : x));

  const [payChoice, setPayChoice] = useState("deposit");
  const payAmount = payChoice === "full" ? totalAll : depositAll;

  const [errors,     setErrs]     = useState({});
  const [sending,    setSending]  = useState(false);
  const [sent,       setSent]     = useState(false);
  const [sendErr,    setSendErr]  = useState("");
  const [bookingRef, setBookingRef] = useState("");
  const [website,    setWebsite]    = useState("");   // honeypot (hidden from customers)

  const validate = () => {
    const e = {};
    if (!lead.firstName.trim())  e.firstName = "Required";
    if (!lead.lastName.trim())   e.lastName  = "Required";
    if (!lead.email.trim() || !lead.email.includes("@")) e.email = "Valid email required";
    if (!lead.phone.trim() || lead.phone.replace(/\s/g, "").length < 10) e.phone = "Valid number required";
    if (!lead.address.trim())    e.address   = "Required";
    if (!lead.postcode.trim())   e.postcode  = "Required";
    if (!lead.terms)             e.terms     = "You must agree to continue";
    paxList.forEach((p, i) => {
      if (!p.firstName.trim()) e[`p${i}fn`] = "Required";
      if (!p.lastName.trim())  e[`p${i}ln`] = "Required";
    });
    setErrs(e);
    return Object.keys(e).length === 0;
  };

  // Where did this customer come from? (Meta ad / Google / direct) — shown to staff
  const sourceLabel = () => {
    try {
      const m = JSON.parse(localStorage.getItem("bh_meta") || "null");
      if (m && Date.now() - m.t < 30 * 864e5) return `Meta ad${m.campaign ? " — " + m.campaign : ""}`;
    } catch (e) { /* ignore */ }
    const r = document.referrer || "";
    if (/google\./i.test(r)) return "Google";
    if (/facebook|instagram/i.test(r)) return "Facebook / Instagram";
    return "Website";
  };

  // Backup email (Web3Forms) — so a request is never lost even if the back office is unreachable
  const sendBackupEmail = async (ref) => {
    const allPax = [
      `Passenger 1 (Lead): ${lead.title} ${lead.firstName} ${lead.lastName}`,
      ...paxList.map((p, i) => `Passenger ${i + 2}: ${p.title} ${p.firstName} ${p.lastName}${p.dob ? ` | DOB: ${p.dob}` : ""}`)
    ].join("\n");
    const payTxt = totalPP <= 0 ? "Enquiry (no price shown)" : payChoice === "full" ? `Pay in full — £${totalAll.toLocaleString()}` : `Low deposit — £${depositAll.toLocaleString()} (balance 10 weeks before travel)`;
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject: `✈️ NEW BOOKING REQUEST ${ref || ""} — ${hotelName} | ${lead.firstName} ${lead.lastName}`,
          from_name: "Broadway Holidays Website",
          replyto: lead.email,
          message: `
NEW BOOKING REQUEST ${ref ? "— " + ref : "(not saved in back office — please add manually)"}
No payment taken online. Call the customer to confirm and take payment.
============================

BOOKING DETAILS
---------------
Hotel:      ${hotelName}
Check-in:   ${fDS2(checkIn)}
Check-out:  ${fDS2(checkOut)}
Duration:   ${nights} nights
Board:      ${board}
Guests:     ${guests}${rooms > 1 ? ` (${rooms} rooms)` : ""}
Price shown: ${totalPP > 0 ? `£${totalPP}pp · Total £${totalAll.toLocaleString()}` : "—"}
Payment preference: ${payTxt}

LEAD PASSENGER & CONTACT
------------------------
Name:     ${lead.title} ${lead.firstName} ${lead.lastName}
Email:    ${lead.email}
Phone:    ${lead.phone}
Address:  ${lead.address}, ${lead.postcode}

ALL PASSENGERS
--------------
${allPax}

SPECIAL REQUESTS
----------------
${lead.specialReq || "None"}

Came from: ${sourceLabel()}
          `.trim(),
        }),
      });
      const d = await res.json();
      return !!d.success;
    } catch { return false; }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validate()) { window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    setSending(true); setSendErr("");

    let ref = "";
    try {
      const res = await fetch("/backoffice/website-booking-submit.php", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          hotelName, hotelId: sp.get("hotelId") || "", checkIn, checkOut, board, guests, rooms,
          pricePP: totalPP, payChoice: totalPP > 0 ? payChoice : "enquiry",
          lead: { title: lead.title, firstName: lead.firstName, lastName: lead.lastName, email: lead.email,
                  phone: lead.phone, address: lead.address, postcode: lead.postcode, specialReq: lead.specialReq },
          passengers: paxList,
          source: sourceLabel(),
          pageUrl: window.location.pathname + window.location.search,
          website,
        }),
      });
      const d = await res.json().catch(() => ({}));
      if (d.ok && d.ref) ref = d.ref;
      else if (d.error && res.status === 400) { setSendErr(d.error); setSending(false); return; }
    } catch { /* fall through to the backup email */ }

    const emailed = await sendBackupEmail(ref);
    if (ref || emailed) {
      setBookingRef(ref);
      setSent(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setSendErr("We couldn't send your request — please call 020 3019 0055 or WhatsApp us and we'll book it for you.");
    }
    setSending(false);
  };

  if (sent) return (
    <>
      <Navbar />
      <div style={{ background: "#f3f6fb", minHeight: "100vh", padding: "52px 20px" }}>
        <div style={{ maxWidth: 580, margin: "0 auto" }}>
          <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 18, padding: "44px 36px", textAlign: "center", boxShadow: "0 6px 32px rgba(11,31,58,.08)" }}>
            <div style={{ width: 76, height: 76, borderRadius: "50%", background: "#ecfdf5", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 22px" }}>
              <I.Tick s={40} />
            </div>
            <h1 style={{ fontSize: 26, fontWeight: 900, color: NAV, margin: "0 0 10px", ...PJS }}>Booking Request Received!</h1>
            <p style={{ fontSize: 15, color: "#64748b", margin: "0 0 6px", lineHeight: 1.75, ...DS }}>
              Thank you <strong>{lead.firstName}</strong>! We've received your booking request
              {bookingRef && <> — your reference is <strong style={{ color: NAV }}>{bookingRef}</strong></>}.
            </p>
            <p style={{ fontSize: 14, color: "#64748b", margin: "0 0 22px", lineHeight: 1.75, ...DS }}>
              <strong>No payment has been taken.</strong> A member of our UK team will call you on{" "}
              <strong>{lead.phone}</strong> within <strong>2 hours</strong> to confirm availability and your price,
              and arrange {totalPP > 0 ? (payChoice === "deposit" ? "your deposit" : "your payment") : "the details"} securely.
            </p>
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 12, padding: "16px", textAlign: "left", marginBottom: 26 }}>
              <div style={{ fontWeight: 800, fontSize: 12, color: NAV, marginBottom: 10, ...PJS, textTransform: "uppercase", letterSpacing: ".04em" }}>Your Booking</div>
              {[
                ["Hotel",     hotelName],
                ["Check-in",  fDS2(checkIn)],
                ["Check-out", fDS2(checkOut)],
                ["Duration",  `${nights} nights`],
                ["Board",     board],
                ["Guests",    `${guests} adult${guests !== 1 ? "s" : ""}`],
                ...(bookingRef ? [["Reference", bookingRef]] : []),
                ...(totalPP > 0 ? [["Price shown", `£${totalAll.toLocaleString()} (£${totalPP}pp)`],
                                   ["You chose",   payChoice === "deposit" ? `Low deposit £${depositAll.toLocaleString()}` : "Pay in full"]] : []),
              ].map(([l, v], i, arr) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: i < arr.length - 1 ? "1px solid #f1f5f9" : "none", fontSize: 13 }}>
                  <span style={{ color: "#64748b", ...DS }}>{l}</span>
                  <span style={{ fontWeight: 600, color: NAV, ...DS }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <a href={`https://wa.me/447487672075?text=${encodeURIComponent(`Hi, I've just sent a booking request${bookingRef ? " (" + bookingRef + ")" : ""} for ${hotelName}. My name is ${lead.firstName} ${lead.lastName}.`)}`}
                target="_blank" rel="noreferrer"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "13px 0", background: "#22c55e", color: "#fff", borderRadius: 10, fontWeight: 700, fontSize: 15, textDecoration: "none", ...DS }}>
                <I.WApp s={16} /> Message us on WhatsApp
              </a>
              <a href="tel:02030190055"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "13px 0", background: NAV, color: "#fff", borderRadius: 10, fontWeight: 700, fontSize: 15, textDecoration: "none", ...DS }}>
                <I.Phone s={14} /> Call 020 3019 0055
              </a>
              <Link to="/hotels" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "11px 0", background: "#f8fafc", color: NAV, border: "1px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 14, textDecoration: "none", ...DS }}>
                Search more holidays
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );

  return (
    <>
      <Navbar />
      <div style={{ background: "#f3f6fb", minHeight: "100vh", paddingBottom: 80 }}>
        <div style={{ background: NAV, padding: "28px 20px 24px" }}>
          <div style={{ maxWidth: 1020, margin: "0 auto" }}>
            <nav style={{ display: "flex", gap: 5, alignItems: "center", marginBottom: 12, fontSize: 12, ...DS }}>
              <Link to="/" style={{ color: "rgba(255,255,255,.6)", textDecoration: "none" }}>Home</Link>
              <span style={{ color: "rgba(255,255,255,.3)" }}>›</span>
              <span style={{ color: "rgba(255,255,255,.9)" }}>Book Holiday</span>
            </nav>
            <h1 style={{ fontSize: 22, fontWeight: 900, color: "#fff", margin: "0 0 4px", ...PJS }}>Complete your booking</h1>
            <p style={{ fontSize: 14, color: "rgba(255,255,255,.65)", margin: 0, ...DS }}>
              {totalPP > 0 ? "Send your request now — no payment taken online. We'll call you to confirm and arrange payment." : "Fill in your details — we'll confirm within 2 hours"}
            </p>
          </div>
        </div>

        <div style={{ maxWidth: 1020, margin: "0 auto", padding: "28px 20px" }}>
          <form onSubmit={handleSubmit} noValidate>
            <input type="text" name="website" value={website} onChange={e => setWebsite(e.target.value)}
              tabIndex={-1} autoComplete="off" aria-hidden="true"
              style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} />
            <div className="co-grid" style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 20, alignItems: "flex-start" }}>
              <div>
                <div style={{ background: `linear-gradient(135deg,${NAV},${NAVL})`, borderRadius: 12, padding: "14px 18px", marginBottom: 16, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 14, color: "#fff", ...PJS }}>{hotelName}</div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,.65)", ...DS }}>{fDS2(checkIn)} – {fDS2(checkOut)} · {nights} nights · {guests} guest{guests !== 1 ? "s" : ""}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ background: bcc.bg, color: bcc.txt, borderRadius: 5, padding: "3px 10px", fontSize: 11, fontWeight: 700, ...DS }}>{board}</span>
                    {totalPP > 0 && <span style={{ fontSize: 18, fontWeight: 900, color: "#fff", ...PJS }}>£{totalPP}pp</span>}
                  </div>
                </div>

                {sendErr && (
                  <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "12px 16px", marginBottom: 14, fontSize: 13, color: "#dc2626", ...DS }}>⚠ {sendErr}</div>
                )}

                {totalPP > 0 && (
                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: "20px 24px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,.03)" }}>
                    <div style={{ fontWeight: 800, fontSize: 14, color: NAV, marginBottom: 14, ...PJS }}>How would you like to pay? <span style={{ fontWeight: 500, fontSize: 12, color: "#64748b" }}>(we'll arrange this with you by phone)</span></div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                      <label onClick={() => setPayChoice("deposit")} style={{ cursor: "pointer" }}>
                        <div style={{ border: `2px solid ${payChoice === "deposit" ? GRN : "#e2e8f0"}`, borderRadius: 12, padding: "14px 16px", background: payChoice === "deposit" ? "#ecfdf5" : "#f8fafc", transition: "all .15s" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
                            <span style={{ fontWeight: 700, fontSize: 13, color: NAV, ...DS }}>Low Deposit</span>
                            <span style={{ width: 18, height: 18, borderRadius: "50%", border: `2px solid ${payChoice === "deposit" ? GRN : "#d1d5db"}`, background: payChoice === "deposit" ? GRN : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                              {payChoice === "deposit" && <I.Check s={10} />}
                            </span>
                          </div>
                          <div style={{ fontSize: 22, fontWeight: 900, color: GRN, ...PJS }}>£{depositAll}</div>
                          <div style={{ fontSize: 11, color: "#64748b", ...DS }}>£{depositPP}pp · Balance 10 wks before travel</div>
                        </div>
                      </label>
                      <label onClick={() => setPayChoice("full")} style={{ cursor: "pointer" }}>
                        <div style={{ border: `2px solid ${payChoice === "full" ? NAV : "#e2e8f0"}`, borderRadius: 12, padding: "14px 16px", background: payChoice === "full" ? "#f0f4ff" : "#f8fafc", transition: "all .15s" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
                            <span style={{ fontWeight: 700, fontSize: 13, color: NAV, ...DS }}>Pay in Full</span>
                            <span style={{ width: 18, height: 18, borderRadius: "50%", border: `2px solid ${payChoice === "full" ? NAV : "#d1d5db"}`, background: payChoice === "full" ? NAV : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                              {payChoice === "full" && <I.Check s={10} />}
                            </span>
                          </div>
                          <div style={{ fontSize: 22, fontWeight: 900, color: NAV, ...PJS }}>£{totalAll.toLocaleString()}</div>
                          <div style={{ fontSize: 11, color: "#64748b", ...DS }}>£{totalPP}pp · Nothing more to pay</div>
                        </div>
                      </label>
                    </div>
                  </div>
                )}

                <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: "22px 24px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,.03)" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
                    <div style={{ width: 28, height: 28, borderRadius: "50%", background: NAV, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0, ...PJS }}>1</div>
                    <div>
                      <div style={{ fontWeight: 800, fontSize: 15, color: NAV, ...PJS }}>Lead Passenger & Contact</div>
                      <div style={{ fontSize: 11, color: "#94a3b8", ...DS }}>We'll call this number to confirm your booking</div>
                    </div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "90px 1fr 1fr", gap: 10 }}>
                    <Field label="Title"><Sel value={lead.title} onChange={e => setL("title", e.target.value)}>{["Mr","Mrs","Ms","Miss","Dr","Prof"].map(t=><option key={t}>{t}</option>)}</Sel></Field>
                    <Field label="First Name" required error={errors.firstName}><Input value={lead.firstName} onChange={e=>setL("firstName",e.target.value)} placeholder="John" error={errors.firstName}/></Field>
                    <Field label="Last Name" required error={errors.lastName}><Input value={lead.lastName} onChange={e=>setL("lastName",e.target.value)} placeholder="Smith" error={errors.lastName}/></Field>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <Field label="Email Address" required error={errors.email}><Input type="email" value={lead.email} onChange={e=>setL("email",e.target.value)} placeholder="john@example.com" error={errors.email}/></Field>
                    <Field label="Mobile Number" required error={errors.phone}><Input type="tel" value={lead.phone} onChange={e=>setL("phone",e.target.value)} placeholder="07700 000000" error={errors.phone}/></Field>
                  </div>
                  <Field label="Home Address" required error={errors.address}><Input value={lead.address} onChange={e=>setL("address",e.target.value)} placeholder="123 High Street, London" error={errors.address}/></Field>
                  <Field label="Postcode" required error={errors.postcode}><Input value={lead.postcode} onChange={e=>setL("postcode",e.target.value)} placeholder="SW1A 1AA" error={errors.postcode}/></Field>
                </div>

                {paxList.map((p, i) => (
                  <div key={i} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: "22px 24px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,.03)" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
                      <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#64748b", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0, ...PJS }}>{i+2}</div>
                      <div>
                        <div style={{ fontWeight: 800, fontSize: 15, color: NAV, ...PJS }}>Passenger {i+2}</div>
                        <div style={{ fontSize: 11, color: "#94a3b8", ...DS }}>Additional traveller</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "90px 1fr 1fr", gap: 10 }}>
                      <Field label="Title"><Sel value={p.title} onChange={e=>setPax(i,"title",e.target.value)}>{["Mr","Mrs","Ms","Miss","Dr","Prof"].map(t=><option key={t}>{t}</option>)}</Sel></Field>
                      <Field label="First Name" required error={errors[`p${i}fn`]}><Input value={p.firstName} onChange={e=>setPax(i,"firstName",e.target.value)} placeholder="Jane" error={errors[`p${i}fn`]}/></Field>
                      <Field label="Last Name" required error={errors[`p${i}ln`]}><Input value={p.lastName} onChange={e=>setPax(i,"lastName",e.target.value)} placeholder="Smith" error={errors[`p${i}ln`]}/></Field>
                    </div>
                    <Field label="Date of Birth" hint="(optional)"><Input type="date" value={p.dob} onChange={e=>setPax(i,"dob",e.target.value)}/></Field>
                  </div>
                ))}

                <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: "20px 24px", marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,.03)" }}>
                  <Field label="Special Requests" hint="(optional)">
                    <textarea value={lead.specialReq} onChange={e=>setL("specialReq",e.target.value)}
                      placeholder="Dietary requirements, room preferences, anniversaries, accessibility needs…"
                      style={{ width:"100%",padding:"11px 13px",border:"1.5px solid #d1d5db",borderRadius:9,fontSize:14,...DS,minHeight:80,resize:"vertical",outline:"none",boxSizing:"border-box",lineHeight:1.6 }}/>
                  </Field>
                  <label style={{ display:"flex",alignItems:"flex-start",gap:10,cursor:"pointer",fontSize:13,...DS }} onClick={()=>setL("terms",!lead.terms)}>
                    <span style={{ width:18,height:18,border:`1.5px solid ${errors.terms?"#fca5a5":"#d1d5db"}`,borderRadius:4,background:lead.terms?NAV:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1,transition:"all .15s",pointerEvents:"none" }}>
                      {lead.terms&&<I.Check s={11}/>}
                    </span>
                    <span style={{ color:"#374151",pointerEvents:"none",lineHeight:1.55 }}>
                      I agree to the{" "}<Link to="/terms" target="_blank" style={{color:GRN,fontWeight:700}} onClick={e=>e.stopPropagation()}>Terms & Conditions</Link>{" "}and{" "}<Link to="/privacy" target="_blank" style={{color:GRN,fontWeight:700}} onClick={e=>e.stopPropagation()}>Privacy Policy</Link>
                    </span>
                  </label>
                  {errors.terms&&<div style={{fontSize:11,color:"#dc2626",marginTop:4,marginLeft:28,...DS}}>⚠ {errors.terms}</div>}
                </div>

                <button type="submit" disabled={sending}
                  style={{ width:"100%",padding:"16px 0",background:sending?"#94a3b8":NAV,color:"#fff",border:"none",borderRadius:12,fontSize:16,fontWeight:900,cursor:sending?"not-allowed":"pointer",...PJS,display:"flex",alignItems:"center",justifyContent:"center",gap:8,transition:"background .15s" }}
                  onMouseEnter={e=>{if(!sending)e.currentTarget.style.background=NAVL;}}
                  onMouseLeave={e=>{if(!sending)e.currentTarget.style.background=NAV;}}>
                  {sending?(<><span style={{width:16,height:16,border:"2.5px solid rgba(255,255,255,.35)",borderTopColor:"#fff",borderRadius:"50%",animation:"spin .7s linear infinite",display:"inline-block"}}/> Sending your request…</>)
                  :totalPP>0?(<>Send Booking Request <I.Right s={15}/></>)
                  :(<>Send Booking Enquiry <I.Right s={15}/></>)}
                </button>

                {totalPP>0&&(
                  <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginTop:10,fontSize:12,color:"#94a3b8",...DS}}>
                    <I.Lock s={11}/> No card details needed now · We'll call you within 2 hours to confirm
                  </div>
                )}

                <div style={{marginTop:12,padding:"14px",background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:10,textAlign:"center"}}>
                  <div style={{fontSize:12,color:"#64748b",marginBottom:9,...DS}}>Prefer to book by phone?</div>
                  <div style={{display:"flex",gap:10,justifyContent:"center"}}>
                    <a href="tel:02030190055" style={{display:"flex",alignItems:"center",gap:6,padding:"9px 16px",background:NAV,color:"#fff",borderRadius:8,fontWeight:700,fontSize:13,textDecoration:"none",...DS}}>
                      <I.Phone s={13}/> 020 3019 0055
                    </a>
                    <a href={`https://wa.me/447487672075?text=${encodeURIComponent(`Hi, I'd like to book ${hotelName}`)}`} target="_blank" rel="noreferrer"
                      style={{display:"flex",alignItems:"center",gap:6,padding:"9px 16px",background:"#22c55e",color:"#fff",borderRadius:8,fontWeight:700,fontSize:13,textDecoration:"none",...DS}}>
                      <I.WApp s={14}/> WhatsApp
                    </a>
                  </div>
                </div>
              </div>

              <div style={{position:"sticky",top:80}}>
                <div style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:14,overflow:"hidden",boxShadow:"0 4px 20px rgba(11,31,58,.07)"}}>
                  <div style={{background:`linear-gradient(135deg,${NAV},${NAVL})`,padding:"18px"}}>
                    <div style={{fontSize:10,color:"rgba(255,255,255,.55)",...DS,textTransform:"uppercase",letterSpacing:".06em",marginBottom:3}}>Hotel Price</div>
                    {totalPP>0?<>
                      <div style={{display:"flex",alignItems:"baseline",gap:4,marginBottom:4}}>
                        <span style={{fontSize:10,color:"rgba(255,255,255,.6)",...DS}}>From</span>
                        <span style={{fontSize:32,fontWeight:900,color:"#fff",lineHeight:1,...PJS}}>£{totalPP}</span>
                        <span style={{fontSize:12,color:"rgba(255,255,255,.6)",...DS}}>pp</span>
                      </div>
                      <div style={{fontSize:11,color:"rgba(255,255,255,.6)",...DS}}>
                        {pax} guest{pax!==1?"s":""}: <strong style={{color:"#fff"}}>£{totalAll.toLocaleString()}</strong>{" "}· Deposit: <strong style={{color:"#6ee7b7"}}>£{depositPP}pp</strong>
                      </div>
                    </>:<div style={{fontSize:14,color:"rgba(255,255,255,.65)",...DS}}>Enquiry</div>}
                  </div>
                  <div style={{padding:"14px 16px"}}>
                    <div style={{background:bcc.light,border:`1px solid ${bcc.bg}44`,borderRadius:7,padding:"7px 10px",display:"flex",gap:7,alignItems:"center",marginBottom:12}}>
                      <span style={{background:bcc.bg,color:bcc.txt,borderRadius:4,padding:"2px 8px",fontSize:10,fontWeight:700,...DS}}>{board}</span>
                      <span style={{fontSize:11,color:"#374151",...DS}}>Included</span>
                    </div>
                    {[["🏨",hotelName],["📅",`${fDS2(checkIn)} — ${fDS2(checkOut)}`],["🌙",`${nights} night${nights!==1?"s":""}`],["👥",`${guests} adult${guests!==1?"s":""}${rooms>1?`, ${rooms} rooms`:""}`]].map(([ico,txt],i)=>(
                      <div key={i} style={{display:"flex",gap:7,alignItems:"flex-start",padding:"3px 0",fontSize:12,color:"#475569",...DS}}>
                        <span style={{flexShrink:0}}>{ico}</span><span style={{lineHeight:1.4}}>{txt}</span>
                      </div>
                    ))}
                    {totalPP>0&&<>
                      <div style={{height:1,background:"#f1f5f9",margin:"10px 0"}}/>
                      {[["Per person",`£${totalPP}`,false],[`Total (${pax}p)`,`£${totalAll.toLocaleString()}`,true]].map(([l,v,b],i)=>(
                        <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12}}>
                          <span style={{color:"#64748b",...DS}}>{l}</span>
                          <span style={{fontWeight:b?800:600,color:b?GRN:NAV,...DS}}>{v}</span>
                        </div>
                      ))}
                      <div style={{background:"#ecfdf5",border:"1px solid #a7f3d0",borderRadius:8,padding:"10px",marginTop:10,textAlign:"center"}}>
                        <div style={{fontSize:11,fontWeight:700,color:"#065f46",...DS}}>Low deposit from</div>
                        <div style={{fontSize:20,fontWeight:900,color:"#065f46",...PJS}}>£{depositPP}pp</div>
                        <div style={{fontSize:10,color:"#047857",...DS}}>Balance 10 weeks before travel</div>
                      </div>
                      <div style={{background:"#f0f4ff",border:"1px solid #c7d2fe",borderRadius:8,padding:"10px",marginTop:8,textAlign:"center"}}>
                        <div style={{fontSize:11,fontWeight:700,color:NAV,...DS}}>Due once we confirm</div>
                        <div style={{fontSize:20,fontWeight:900,color:NAV,...PJS}}>£{payAmount.toLocaleString()}</div>
                        <div style={{fontSize:10,color:"#4338ca",...DS}}>{payChoice==="deposit"?"Deposit — nothing taken today":"Full payment — nothing taken today"}</div>
                      </div>
                    </>}
                    <div style={{marginTop:12,display:"flex",flexDirection:"column",gap:6}}>
                      {["No hidden fees","Best price promise","No payment taken online","UK team 7 days/week"].map(t=>(
                        <div key={t} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"#334155",...DS}}>
                          <I.Tick s={13}/>{t}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer/>
      <style>{"@keyframes spin{to{transform:rotate(360deg)}}@media(max-width:820px){.co-grid{grid-template-columns:1fr!important}}"}</style>
    </>
  );
}